"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const io_1 = require("react-icons/io");
require("./SuggestionAdmin.css");
const SuggestionAdminTable_1 = __importDefault(require("./Tables/SuggestionAdminTable"));
const SuggestionAdmin = () => {
    const [search, setSearch] = react_1.default.useState("");
    const [dateRange, setDateRange] = react_1.default.useState("");
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleDateRangeChange = (e) => {
        setDateRange(e.target.value);
    };
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Suggestions/remarques"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Suggestions/remarques"))),
                        react_1.default.createElement("div", { className: "row mb-4" },
                            react_1.default.createElement("div", { className: "col-lg-12" },
                                react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
                                    react_1.default.createElement("div", { className: "search-form-group position-relative" },
                                        react_1.default.createElement("span", { className: "search-input-icon" },
                                            react_1.default.createElement(io_1.IoMdSearch, null)),
                                        react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "UsernSearchame", placeholder: "Rechercher...", value: search, onChange: handleSearchChange }))),
                                react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                                    react_1.default.createElement(SuggestionAdminTable_1.default, { search: search, dateRange: dateRange }))))))))));
};
exports.default = SuggestionAdmin;
